function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useCallback, useEffect } from 'react';
// 도메인별 클라이언트 직접 사용 - 각 도메인의 클라이언트 사용
import { getProjects } from '@edusense/edusense-project-client';
import { getApiCourses, GetApiCoursesType, useGetRoadmaps } from '@edusense/course-client';
/**
 * 프로필 페이지의 프로젝트, 코스, 로드맵 관련 상태와 API 호출을 관리하는 훅
 */ export function useProfileContent(param) {
    var userId = param.userId, showToast = param.showToast;
    // 프로젝트 상태
    var _useState = _sliced_to_array(useState([]), 2), userProjects = _useState[0], setUserProjects = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), projectsPage = _useState1[0], setProjectsPage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), hasMoreProjects = _useState2[0], setHasMoreProjects = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), projectsLoading = _useState3[0], setProjectsLoading = _useState3[1];
    // 코스 상태
    var _useState4 = _sliced_to_array(useState([]), 2), userCourses = _useState4[0], setUserCourses = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), coursesPage = _useState5[0], setCoursesPage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(true), 2), hasMoreCourses = _useState6[0], setHasMoreCourses = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), coursesLoading = _useState7[0], setCoursesLoading = _useState7[1];
    // 로드맵 상태
    var _useState8 = _sliced_to_array(useState([]), 2), userRoadmaps = _useState8[0], setUserRoadmaps = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), roadmapsPage = _useState9[0], setRoadmapsPage = _useState9[1];
    var _useState10 = _sliced_to_array(useState(true), 2), hasMoreRoadmaps = _useState10[0], setHasMoreRoadmaps = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), roadmapsLoading = _useState11[0], setRoadmapsLoading = _useState11[1];
    var resolvedUserId = userId != null ? String(userId) : undefined;
    // API 함수들
    var fetchUserProjects = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(userIdParam, page, pageSize) {
            var effectiveUserId, response, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        effectiveUserId = userIdParam || resolvedUserId;
                        if (projectsLoading) return [
                            2
                        ];
                        if (!effectiveUserId) {
                            console.warn('[useProfileContent] fetchUserProjects 호출 시 userId가 정의되지 않았습니다.');
                            return [
                                2
                            ];
                        }
                        setProjectsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getProjects({
                                userId: Number(effectiveUserId),
                                page: page,
                                size: pageSize,
                                type: 'CREATED'
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (page === 0) {
                            setUserProjects(response.content || []);
                        } else {
                            setUserProjects(function(prev) {
                                return _to_consumable_array(prev).concat(_to_consumable_array(response.content || []));
                            });
                        }
                        setHasMoreProjects(!response.last);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('Failed to fetch projects:', error);
                        if (showToast) showToast('프로젝트를 불러오는데 실패했습니다.', 'error');
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setProjectsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(userIdParam, page, pageSize) {
            return _ref.apply(this, arguments);
        };
    }(), [
        projectsLoading,
        showToast,
        resolvedUserId
    ]);
    var fetchUserCourses = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(userIdParam, page, pageSize) {
            var effectiveUserId, response, content, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (coursesLoading) return [
                            2
                        ];
                        effectiveUserId = userIdParam || resolvedUserId;
                        if (!effectiveUserId) {
                            console.warn('[useProfileContent] fetchUserCourses 호출 시 userId가 정의되지 않았습니다.');
                            return [
                                2
                            ];
                        }
                        setCoursesLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getApiCourses({
                                type: GetApiCoursesType.ENROLLED,
                                userId: effectiveUserId,
                                page: page,
                                size: pageSize
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        content = (response === null || response === void 0 ? void 0 : response.content) || [];
                        if (page === 0) {
                            setUserCourses(content);
                        } else {
                            setUserCourses(function(prev) {
                                return _to_consumable_array(prev).concat(_to_consumable_array(content));
                            });
                        }
                        setHasMoreCourses((response === null || response === void 0 ? void 0 : response.last) === false);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('Failed to fetch courses:', error);
                        if (showToast) showToast('코스를 불러오는데 실패했습니다.', 'error');
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setCoursesLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(userIdParam, page, pageSize) {
            return _ref.apply(this, arguments);
        };
    }(), [
        coursesLoading,
        showToast,
        resolvedUserId
    ]);
    var roadmapsQuery = useGetRoadmaps({
        userId: resolvedUserId ? Number(resolvedUserId) : undefined,
        page: roadmapsPage,
        size: 10
    }, {
        query: {
            enabled: false,
            staleTime: 5 * 60 * 1000,
            retry: 1
        }
    });
    var fetchUserRoadmaps = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(userIdParam, page, pageSize) {
            var _response_data, response, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (roadmapsLoading) return [
                            2
                        ];
                        setRoadmapsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            roadmapsQuery.refetch()
                        ];
                    case 2:
                        response = _state.sent();
                        data = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data;
                        if (page === 0) {
                            setUserRoadmaps((data === null || data === void 0 ? void 0 : data.content) || []);
                        } else {
                            setUserRoadmaps(function(prev) {
                                return _to_consumable_array(prev).concat(_to_consumable_array((data === null || data === void 0 ? void 0 : data.content) || []));
                            });
                        }
                        setHasMoreRoadmaps(!(data === null || data === void 0 ? void 0 : data.last));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('Failed to fetch roadmaps:', error);
                        if (showToast) showToast('로드맵을 불러오는데 실패했습니다.', 'error');
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setRoadmapsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(userIdParam, page, pageSize) {
            return _ref.apply(this, arguments);
        };
    }(), [
        roadmapsLoading,
        showToast,
        roadmapsQuery
    ]);
    useEffect(function() {
        setUserProjects([]);
        setProjectsPage(0);
        setHasMoreProjects(true);
        setUserCourses([]);
        setCoursesPage(0);
        setHasMoreCourses(true);
        setUserRoadmaps([]);
        setRoadmapsPage(0);
        setHasMoreRoadmaps(true);
    }, [
        resolvedUserId
    ]);
    return {
        // 상태
        userProjects: userProjects,
        setUserProjects: setUserProjects,
        projectsPage: projectsPage,
        setProjectsPage: setProjectsPage,
        hasMoreProjects: hasMoreProjects,
        setHasMoreProjects: setHasMoreProjects,
        projectsLoading: projectsLoading,
        userCourses: userCourses,
        setUserCourses: setUserCourses,
        coursesPage: coursesPage,
        setCoursesPage: setCoursesPage,
        hasMoreCourses: hasMoreCourses,
        setHasMoreCourses: setHasMoreCourses,
        coursesLoading: coursesLoading,
        userRoadmaps: userRoadmaps,
        setUserRoadmaps: setUserRoadmaps,
        roadmapsPage: roadmapsPage,
        setRoadmapsPage: setRoadmapsPage,
        hasMoreRoadmaps: hasMoreRoadmaps,
        setHasMoreRoadmaps: setHasMoreRoadmaps,
        roadmapsLoading: roadmapsLoading,
        // API 함수들
        fetchUserProjects: fetchUserProjects,
        fetchUserCourses: fetchUserCourses,
        fetchUserRoadmaps: fetchUserRoadmaps
    };
}
